import { useContext, useEffect, useState } from 'react';
import Sections from '~/constants/vdp/sections';
import GlobalContext from '~/context/vdp/GlobalContext';

export default function usePageHash() {
  const { setLazyLoadEnabled } = useContext(GlobalContext);
  const [hash, setHash] = useState('');

  useEffect(() => {
    const setPageHash = () => {
      setHash(window.location.hash.substring(1));
    };

    setPageHash();

    window.addEventListener('hashchange', setPageHash, false);

    return () => {
      window.removeEventListener('hashchange', setPageHash, false);
    };
  }, []);

  useEffect(() => {
    switch (hash) {
      case Sections.Inspection:
      case Sections.FeaturesAndHighlights:
      case Sections.OwnerReviews:
      case Sections.PriceDetails:
      case Sections.VehicleDetails: {
        setLazyLoadEnabled(false);
        break;
      }
      case Sections.Root: {
        // Remove #root from the URL
        window.history.replaceState(
          '',
          document.title,
          window.location.pathname + window.location.search
        );
        break;
      }
      default:
    }
  }, [hash, setLazyLoadEnabled]);
}
